import { FC } from 'react';
import { Link } from 'react-router-dom'
import underTheTree from '../../../assets/under_the_tree.jpg'


export const HeroSection:FC = () => {
    return(
        <div className="relative bg-white pt-16">
          <main className="lg:relative">
            <div className="mx-auto max-w-7xl w-full pt-16 pb-20 text-center lg:py-48 lg:text-left">
              <div className="px-4 lg:w-1/2 sm:px-8 xl:pr-16">
                <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl">
                  <span className="block xl:inline">Nutmeg Wishlists</span>
                  <span className="block text-green-700 xl:inline"> give the best gifts</span>
                </h1>
                <p className="
                  mt-3 max-w-md mx-auto
                  text-lg text-gray-500 sm:text-xl md:mt-5 md:max-w-3xl">
                  Nutmeg Wishlists is a place to create and share wishlists.
                </p>
                <div className="mt-10 sm:flex sm:justify-center lg:justify-start">
                  <div className="rounded-md shadow">
                    <a 
                      href="#LearnMore"
                      className="
                        w-full flex items-center justify-center px-8 py-3 border border-transparent
                        text-base font-medium rounded-md text-white
                        bg-green-800 hover:bg-green-700 md:py-4 md:text-lg md:px-10">
                      Learn More
                    </a>
                  </div>
                  <div className="mt-3 rounded-md shadow sm:mt-0 sm:ml-3">
                    <Link
                      to="/ideas"
                      className="
                        w-full flex items-center justify-center px-8 py-3 border border-transparent
                        text-base font-medium rounded-md text-green-800 bg-white hover:bg-gray-50 md:py-4 md:text-lg md:px-10">
                      Browse Gift Ideas
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full">
              <img
                className="absolute inset-0 w-full h-full object-cover"
                src={underTheTree} alt="under_the_tree.jpg"/>
            </div>
          </main>
        </div>
    )
}
